// extracted by mini-css-extract-plugin
module.exports = {"container":"_b74177b","title":"_e7318d9","marketName":"_525118d"};